import apiSlice from "./ApiSlice";

export const transactionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    getTransactions: builder.query({
      providesTags: ["pay-installment"],
      query: (body) => {
        return {
          url: "/transaction",
          method: "POST",
          body,
        };
      },
    }),

    // Admin Transcation History
    getAdminTransactions: builder.query({
      providesTags: ["pay-installment"],
      query: (body) => {
        return {
          url: "/transaction/filter",
          method: "POST",
          body,
        };
      },
    }),

    //PUT 
     
      updateTranscation: builder.mutation({
        invalidatesTags: ["pay-installment"],
        query: ({ body, id }: any) => {
          return {
            url: `/transaction/${id}`,
            method: "PUT",
            body,
          };
        },
      }),
  }),
});

export const { useGetTransactionsQuery , useUpdateTranscationMutation , useGetAdminTransactionsQuery } = transactionsApi;
